import React from 'react';

import type { Props as FormattedTimeZoneProps } from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';

export interface Props extends Pick<FormattedTimeZoneProps, 'date' | 'hourCycle'> {
  withTime?: boolean;
  format?: 'short' | 'medium' | 'long';
}

const timeProps = {
  hour: 'numeric',
  minute: 'numeric'
} as const;

const SportsFormattedTimeZone: React.FC<Props> = ({ withTime, format, ...rest }) => {
  switch (format) {
    case 'long':
      return (
        <FormattedTimeZone
          {...rest}
          year="numeric"
          month="long"
          day="2-digit"
          weekday="long"
          {...(withTime && timeProps)}
        />
      );

    case 'medium':
      return (
        <FormattedTimeZone
          {...rest}
          year="2-digit"
          month="short"
          day="2-digit"
          weekday="short"
          {...(withTime && timeProps)}
        />
      );

    case 'short':
      return (
        <FormattedTimeZone
          {...rest}
          year="2-digit"
          month="2-digit"
          day="2-digit"
          {...(withTime && timeProps)}
        />
      );

    default:
      return <FormattedTimeZone {...rest} {...(withTime && timeProps)} />;
  }
};

export default SportsFormattedTimeZone;
